// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';

import { setDepartureCity } from 'Store/trip-criteria/departure-city/departureCity.action';
import { setDepartureDate } from 'Store/trip-criteria/departure-date/departureDate.action';
import { setDuration } from 'Store/trip-criteria/duration/duration.action';
import { setKids, resetKids } from 'Store/trip-information/kids/kids.action';
import { setAdultsNumber } from 'Store/trip-information/adults/adults.action';
import { tripInformationSelector } from 'Store/trip-information/storeHelper';
import responsive from 'Components/utils/responsive/Responsive';
import { endLoading } from 'Store/global-loader/globalLoader.action';
import { BookingCriteria } from './BookingCriteria';

const mapDispatchToProps = {
  resetKids,
  setAdultsNumber,
  setDepartureCity,
  setDepartureDate,
  setDuration,
  setKids,
  endLoading,
};

const mapStateToProps = (state: ReduxState) => ({
  tripInformation: tripInformationSelector(state),
});

export const BookingCriteriaContainer = compose(
  responsive,
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true },
  ),
)(BookingCriteria);
